<template>
    <option value="automation/publicApi/v2">Agrology API Key</option>
    <option value="google/service-account/nvdi-earth-engine">Google API Key (NVDI)</option>
    <option value="tomorrow.io/apiKey">TomorrowIO API Key</option>
    <option value="pestProphet/apiKey">PestProphet API Key</option>
</template>
